import ContainerIconValues from "../../data-view/components/waste/ContainerIconValues";
import DropdownDateRange from "components/datetime/DropdownDateRange";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ParamsAsset = ({ item, handleDelete, dateRange, setDateRange }) => {
    const styleLabel = {
        maxWidth: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "end",
    };
    const styleValue = {
        fontSize: "1.1rem",
        fontWeight: "400",
    };

    return (
        <>
            <div className="row">
                <div className="col-12 text-center mb-2" style={{ borderBottom: "1px solid #e9e9e9" }}>
                    <strong>Caracteristicas</strong>
                </div>
                <div className="col-md col-12">
                    <div className="row">
                        <div className="col-12 mb-2">
                            <div className="row mb-2">
                                <div className="col small text-secondary" style={styleLabel}>
                                    Dirección:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.address}, {item.number}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    Población:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.codpost}-{item.municipality}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    Provincia:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.province}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    País:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.country}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md col-12">
                    <div className="row">
                        <div className="col-12 mb-2">
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    Modelo:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.model_name}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    Fabricante:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.manufactured}
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col small text-secondary text-end" style={styleLabel}>
                                    TAG:
                                </div>
                                <div className="col" style={styleValue}>
                                    {item.tag}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md col-12" style={{ minWidth: "268px" }}>
                    <div className="col asset-icon-measures p-2">
                        <ContainerIconValues item={item} />
                    </div>
                </div>
            </div>
            <div className="row ps-4 pe-4">
                <div className="col-12 text-center mb-2" style={{ borderBottom: "1px solid #e9e9e9" }}>
                    <strong>Parametros</strong>
                </div>
                <div className="col text-center">
                    <div className="small">Altura</div>
                    <div>{item.height}</div>
                </div>
                <div className="col text-center">
                    <div className="small">Volumen</div>
                    <div>{item.volume}</div>
                </div>
                <div className="col text-center">
                    <div className="small">Offset</div>
                    <div>{item.offset}</div>
                </div>
                <div className="col text-center">
                    <div className="small">C-Factor</div>
                    <div>{item.c_factor}</div>
                </div>
                <div className="col text-center">
                    <div className="small">D-Factor</div>
                    <div>{item.d_factor}</div>
                </div>
            </div>
            <br />
            <div className="row ps-4 pe-4">
                <div className="col-12 text-center mb-2" style={{ borderBottom: "1px solid #e9e9e9" }}>
                    <strong>Acciones</strong>
                </div>
                <div className="col-12 d-flex justify-content-center mt-3">
                    <button className="btn btn-sm btn-outline-danger me-3" onClick={handleDelete}>
                        <FontAwesomeIcon icon="trash" /> Delete
                    </button>
                    <div style={{ display: "inline-block", minWidth: "200px" }}>
                        <DropdownDateRange size="sm" dateRange={dateRange} setDateRange={setDateRange} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default ParamsAsset;
